import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { SEARCH_PROPERTIES_QUERY } from '../../../../__generated__/chirp/com/hubspot/nlp/crm/search/rpc/propertysearch/NlpPropertySearchService.dfc';
import { useFieldOptions } from '../../../hooks/useFieldOptions';
const SEARCH_PROPERTIES_QUERY_RESULT_LIMIT = 5;
const SEARCH_PROPERTIES_QUERY_SIMILARITY_THRESHOLD = 0.75;
export const useSuggestedProperties = ({
  searchString,
  filterFamily,
  hiddenProperties
}) => {
  const {
    loading,
    error,
    data
  } = useQuery(SEARCH_PROPERTIES_QUERY, {
    variables: {
      input: [searchString],
      resultLimit: SEARCH_PROPERTIES_QUERY_RESULT_LIMIT,
      similarityThreshold: SEARCH_PROPERTIES_QUERY_SIMILARITY_THRESHOLD,
      propertySearchFilters: {
        objectTypeId: filterFamily
      }
    }
  });
  const {
    options: fieldOptions
  } = useFieldOptions(filterFamily, '', hiddenProperties);
  const options = useMemo(() => {
    if (loading || error || !fieldOptions) {
      return undefined;
    }
    const propertyMatches = data === null || data === void 0 ? void 0 : data.searchProperties.response[searchString];
    if (!propertyMatches) {
      return [];
    }

    // Identify the property matches that have corresponding fields in the fieldOptions
    return propertyMatches.reduce((acc, match) => {
      const propertyName = match.property.name;
      const matchedField = fieldOptions.find(field => field.name === propertyName);
      if (matchedField) {
        acc.push(matchedField);
      }
      return acc;
    }, Array());
  }, [fieldOptions, loading, data, error, searchString]);
  return {
    options,
    loading,
    error
  };
};